import React from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { TutoComputerWrapper } from 'components/install-app-tuto/tuto-computer/TutoComputer.styled';
import { APP_STORES } from 'constants/global';
import useAutoLoginUrl from 'hooks/useAutoLoginUrl';

const QR_SIZE = 256;

const TutoComputer: React.FC = () => {
  const { t } = useTranslation('translation');
  const autoLoginUrl = useAutoLoginUrl();

  return (
    <TutoComputerWrapper>
      <ol className="steps">
        {/* Step 1: download the app (one QR code per platform) */}
        <li className="step">
          <div className="step-number">{t('common.step', { number: 1 })}</div>
          <div className="step-title">{t('settings.installation.steps.download.title')}</div>
          <p className="step-hint">{t('settings.installation.steps.download.computer_hint')}</p>
          <div className="qr-codes">
            <figure className="qr-code-wrapper">
              <QRCode className="qr-code" size={QR_SIZE} value={APP_STORES.IOS} />
              <figcaption>{t('settings.installation.steps.download.ios')}</figcaption>
            </figure>
            <figure className="qr-code-wrapper">
              <QRCode className="qr-code" size={QR_SIZE} value={APP_STORES.ANDROID} />
              <figcaption>{t('settings.installation.steps.download.android')}</figcaption>
            </figure>
          </div>
        </li>
        {/* Step 2: log into the app (auto-login QR code) */}
        <li className="step">
          <div className="step-number">{t('common.step', { number: 2 })}</div>
          <div className="step-title">{t('settings.installation.steps.credentials.title')}</div>
          <p className="step-hint">{t('settings.installation.steps.credentials.computer_hint')}</p>
          <div className="qr-codes">
            <figure className="qr-code-wrapper">
              {autoLoginUrl ? (
                <QRCode className="qr-code" size={QR_SIZE} value={autoLoginUrl} />
              ) : (
                <div className="qr-code qr-code-placeholder" />
              )}
              <figcaption>{t('settings.installation.steps.credentials.caption')}</figcaption>
            </figure>
          </div>
        </li>
      </ol>
      <p className="ready">{t('settings.installation.steps.ready')}</p>
    </TutoComputerWrapper>
  );
};

export default TutoComputer;
